
import { computed, defineComponent, Ref, ref, watchEffect } from 'vue'

export default defineComponent({
    props: {
        url: {
            type: String,
            required: true,
        },
    },
    setup() {
        const audioPlayer = ref(null) as Ref<HTMLAudioElement | null>
        const disabled = ref(true)

        const volume = ref(1)
        const currentTime = ref(0)
        const duration = ref(0)
        const playing = ref(false)

        const formatTime = (timeInSeconds: number) => {
            const minutes = Math.floor(timeInSeconds / 60)
            const seconds = Math.floor(timeInSeconds % 60)
            return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
        }

        const onUpdateTime = () => {
            if (!audioPlayer.value) return

            currentTime.value = audioPlayer.value.currentTime
            duration.value = audioPlayer.value.duration
        }

        const onAudioEnded = () => {
            playing.value = false
        }

        const toggle = () => {
            if (!audioPlayer.value || disabled.value) return

            if (playing.value) {
                audioPlayer.value.pause()
            } else {
                audioPlayer.value.play()
            }

            playing.value = !playing.value
        }

        watchEffect(() => {
            if (audioPlayer.value) {
                audioPlayer.value.volume = volume.value

                audioPlayer.value.onloadedmetadata = () => {
                    duration.value = audioPlayer.value ? audioPlayer.value.duration : 0
                    disabled.value = false
                }
            }
        })

        const progress = computed(() => {
            return (currentTime.value / duration.value) * 100
        })

        return {
            audioPlayer,
            currentTime,
            duration,
            playing,
            formatTime,
            onUpdateTime,
            onAudioEnded,
            toggle,
            progress,
            disabled,
        }
    },
})
